module.exports = __webpack_public_path__ + "static/img/record-count.057d6c09.png";